import { RulebookPage } from '../../../../shared/enums/RulebookEnums.ts';
import { UIPopupRulebook } from '../ui_popup/UIPopupRulebook.ts';
let rulebookPopupGlobal;
export function showRulebookPopup(page = RulebookPage.Classic4P) {
    if (rulebookPopupGlobal == undefined) rulebookPopupGlobal = new UIPopupRulebook(page);
    rulebookPopupGlobal.setDefaultPage(page);
    rulebookPopupGlobal.show();
}
